import React, {useContext} from 'react';
import {Row, Col} from 'reactstrap';
import ErrorBoundary from '@/ErrorBoundary';
import {userCtx} from '@/auth';
import {SystemConfigCtx} from '@/contexts';
import {blank} from '@/util';

import ProducerNav from '@/views/Layout/b2b/ProducerNavBar/index';
import {ProducerStateProvider} from '@/views/Layout/b2b/ProducerNavBar/state';
import MenuList from '@/views/Layout/b2b/MenuList';
import SortableList from '@/views/Layout/b2b/SortableList';
import AvenueLink from '@/views/Layout/b2b/AvenueLink';

import styles from '@/views/Layout/b2b/index.module.css';

// b2b
import B2bRouterSwitch from '@/b2b/Routes';

import Header from '@/views/Layout/b2b/Header';
import Footer from '@/views/Layout/b2b/Footer';

const B2b = ({match}) => {
  // FIXME: want to remove initialState to producerState function
  // but Hooks can only be called inside the body of a function component
  const user = useContext(userCtx);
  const {siteCode} = useContext(SystemConfigCtx);

  const initialState = {
    producerName: user.currentProducer.name,
    producerFullName: user.currentProducer.fullName,
    producerId: user.currentProducer.producerId,
  };

  if (blank(siteCode)) {
    return null;
  }

  return (
    <div style={{marginTop: siteCode === 'absg' ? '80px' : '150px'}}>
      <link rel='stylesheet' href='/header/styles.css' />
      <ProducerStateProvider initialState={initialState}>
        <Header />
        <ErrorBoundary>
          <div style={{marginLeft: '50px'}}>
            <ProducerNav />
          </div>
          <main className={styles.main_b2b_body}>
            <Row>
              <Col md={2}>
                <MenuList />
                <SortableList />
                <AvenueLink />
              </Col>
              <Col md={10}>
                <B2bRouterSwitch match={match} />
              </Col>
            </Row>
          </main>
        </ErrorBoundary>
      </ProducerStateProvider>
      <Footer />
    </div>
  );
};

export default B2b;
